import { useEffect } from 'react'

type EventType = 'paste' | 'copy'

interface RestrictCopyPasteProps {
  window: Window
  actions: [EventType?, EventType?]
}

export const useRestrictCopyPaste = (props: RestrictCopyPasteProps) => {
  useEffect(() => {
    props.actions?.forEach(action => {
      action && window.addEventListener(action, preventPaste, { capture: true })
    })

    return () => {
      props.actions.forEach(action => {
        action && window.removeEventListener(action, preventPaste)
      })
    }
  }, [props.window, props.actions])

  const preventPaste = (e: Event) => {
    if (document.activeElement?.tagName.toLowerCase() !== 'input') {
      e.preventDefault()
      e.stopImmediatePropagation()
    }
  }
}
